<template v-show="show">
  <div class="page-prodetail collect-matchs-detail">
    <el-breadcrumb class="add-breadcrumb proo" separator="/">
        <el-breadcrumb-item :to="{ path: '/nAnimateMake',query:{ plate: 3 } }">动画制作</el-breadcrumb-item>
      <el-breadcrumb-item to="/project?plate=3">项目大厅</el-breadcrumb-item>
      <el-breadcrumb-item>项目详情</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- <div class="much">当前已有<span>{{activityInfo.quoteNum}}</span>人报价该项目</div> -->
    <div class="projn-list">
      <div class="projn-item">
        <div
          class="left-img"
          :style="{backgroundImage: 'url(' + require('@/assets/images/gs.jpg') + ')'}"
        >
        </div>
        <div class="itemn-info">
          <div class="item-tit">
            <div class="tit-type clearfix">
              <div class="tit-nam">{{ activityInfo.activityName }}</div>
              <span class="type bjz" v-if="activityInfo.showStatus == '报价中'">{{ activityInfo.showStatus }}</span>
              <span class="type yjs" v-if="activityInfo.showStatus == '已结束'">{{ activityInfo.showStatus }}</span>
            </div>
            <span class="item-date">{{activityInfo.formatDateStr}}</span>
          </div>
          <div class="pro-type">项目类型：{{activityInfo.showProType}}</div>
          <div class="pro-end-date">报价截止时间：{{activityInfo.showTime}}</div>
          <div class="btn-has-user">
            <el-button class="bj-btn" size="mini" type="danger" @click="quoted">报价</el-button>
<!--            <el-button class="bj-btn" size="mini" type="danger">进入项目</el-button>-->
            <div class="hs-user">{{activityInfo.quoteNum}}人参与报价</div>
          </div>
        </div>
      </div>
    </div>
    <div class="rich-text article-center-cont" v-html="activityInfo.activityDescription">

    </div>
    <ul class="right-side-btns">
      <li @click="quoted">报&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;价</li>
      <li @click="share">分&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;享</li>
      <!--<li @click="goChatRoom">咨&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;询</li>-->
      <router-link to="/recruit?plate=3"><li>招募合伙人</li></router-link>
    </ul>
    <el-dialog
      title="项目报价"
      :visible.sync="dialogBaojia"
      :close-on-click-modal="false"
      center
      :width="$store.state.app.device === 'desktop' ? '600px' : '90%'"
      append-to-body
    >
      <div class="dialog-form">
        <div class="form-item">
          <div class="tit">用户昵称</div>
          <div class="rig-ipt">
            {{formOption.commiterName}}
          </div>
        </div>
        <div class="form-item">
          <div class="tit">手机号</div>
          <div class="rig-ipt">
<!--            {{formOption.mobile}}-->
            <el-input
                    v-model="formOption.mobile"
                    placeholder="请输入手机验证码"
            >
            </el-input>
          </div>
        </div>
        <div class="form-item">
          <div class="tit">验证码</div>
          <div class="rig-ipt yz-ipt">
            <el-input
              v-model="registerImgCode"
              placeholder="请输入验证码"
              class="ipt"
            >
            </el-input>
            <div class="yz-img">
              <img :src="registerCheckImg" alt="">
            </div>
          </div>
        </div>
        <div class="form-item">
          <div class="tit"></div>
          <div class="rig-ipt yz-ipt">
            <el-input
              v-model="registerYzm"
              placeholder="请输入手机验证码"
            >
            </el-input>
<!--            <el-button class="yz-img" type="primary">发送验证码</el-button>-->
            <el-button
                    class="yz-img"
                    :type="time === 0 ? 'primary' : 'info'"
                    :disabled="time === 0 ? false : true"
                    @click="setTime"
            >
              {{time === 0 ? '发送验证码' : time + '秒后重发'}}
            </el-button>
          </div>
        </div>
        <div class="form-item">
          <div class="tit">报价金额</div>
          <div class="rig-ipt">
            <el-input
              @input="handleInput"
              v-model="formOption.projectOffer"
              placeholder="请输入报价金额"
            >
              <span slot="suffix">元</span>
            </el-input>
          </div>
        </div>
        <div class="xieyi">
          <el-checkbox v-model="checked">同意提交报价即代表竞价成功后签署</el-checkbox><span @click="dialogXieyi = true">合作协议</span>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button :type="checked === true ? 'primary' : 'info'" @click="addResult"  :loading="loading">提交报价</el-button>
      </span>
      <el-dialog
        :visible.sync="dialogXieyi"
        :width="$store.state.app.device === 'desktop' ? '70%' : '95%'"
        :top="$store.state.app.device === 'desktop' ? '60px' : '10px'"
        :close-on-click-modal="false"
        append-to-body
        center
      >
        <xie-yi></xie-yi>

        <span slot="footer" class="dialog-footer">
          <el-button type="primary"  @click="dialogXieyi = false">确 定</el-button>
        </span>
      </el-dialog>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="dialogNoqx2"
      :close-on-click-modal="false"
      center
      :width="$store.state.app.device === 'desktop' ? '600px' : '90%'"
    >
      <div class="get-qx">
        <span class="act-words">您还没有项目合伙人权限，请申请权限</span>
<!--        <a href="" class="qx-a">申请合伙人权限</a>-->
        <el-button @click="applyFor">点击申请合伙人</el-button>
      </div>
    </el-dialog>
    <el-dialog
            title="提示"
            :visible.sync="dialogNoqx3"
            :close-on-click-modal="false"
            center
            :width="$store.state.app.device === 'desktop' ? '600px' : '90%'"
    >
      <div class="get-qx">
        <span class="act-words">您还没有项目合伙人权限，尚未发布作品，请先发布作品</span>
<!--        <a href="http://i.renrendonghua.com" class="qx-a">点击去个人中心发布作品</a>-->
        <el-button @click="applyForAndGotoI">点击发布作品</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="dialogActover"
      :close-on-click-modal="false"
      center
      :width="$store.state.app.device === 'desktop' ? '600px' : '90%'"
    >
      <span class="act-words">该项目已结束，无法报价</span>
    </el-dialog>
    <el-dialog
            title="分享到"
            class="common-dialog"
            :visible.sync="dialogVisibleShare"
            :close-on-click-modal="false"
            :modal-append-to-body="false"
            append-to-body
    >
      <ul class="dialog-share-list clearfix">
        <li>
          <div class="img-f" @click="shareMy">
            <img :src="require('@/assets/images/share_01.png')" alt="" />
          </div>
          <p>我的动态</p>
        </li>
        <li @click="shareWechat">
          <div class="img-f">
            <img :src="require('@/assets/images/share_02.png')" alt="" />
          </div>
          <p>微信</p>
        </li>
        <li @click="shareWeibo">
          <div class="img-f">
            <img :src="require('@/assets/images/share_03.png')" alt="" />
          </div>
          <p>微博</p>
        </li>
        <li @click="shareQQzone">
          <div class="img-f">
            <img :src="require('@/assets/images/share_04.png')" alt="" />
          </div>
          <p>QQ空间</p>
        </li>
        <li class="tag-read" :data-clipboard-text="shareUrl2" @click="copyLink">
          <div class="img-f">
            <img :src="require('@/assets/images/share_06.png')" alt="" />
          </div>
          <p>复制链接</p>
        </li>
      </ul>
      <el-dialog
              title="分享到微信"
              class="common-dialog"
              :visible.sync="dialogVisibleShareWechat"
              :close-on-click-modal="false"
              append-to-body
      >
        <div ref="qrcode" id="qrcode" class="dialog-share-wechat"></div>
      </el-dialog>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
  import global_ from '@/api/global'
  import apiService from '@/api/index'
  import updateTdk from "@/utils/tdk";
  import vue from 'vue';
  import qs from 'qs';
  import Clipboard from 'clipboard';
  import xieYi from './xieyi'
  import {mapState} from "vuex";
  vue.prototype.qs = qs;
export default {
  components: {
    xieYi
  },
  data () {
    return {
      loading:false,
      dialogBaojia: false,
      dialogNoqx2: false,
      dialogNoqx3: false,
      dialogActover: false,
      formOption: {},
      headTitle: "title---rrdh",
      headKeywords: "keywords---rrdh",
      headDesc: "description---rrdh",
      isMounted: false, //for control not ssr render
      show:false,
      shareUrl:"",
      shareUrl2:"",
      id:"",
      activityInfo:{},
      productionList:[],
      dialogVisibleShare: false,
      dialogVisibleShareWechat: false,
      total:0,
      index:0,
      currentPage:1,
      fullscreenLoading: true,
      is_prize:0,
      userId:0,
      time:0,
      registerImgCode: '',
      registerCheckImg: '',
      registerYzm: '',
      checked:false,
      dialogXieyi: false
    }
  },
  tdk() {
    return {
      title: this.headTitle,
      description: this.headDesc,
      keywords: this.headKeywords,
      ssrHeadAddInfo: `<link rel="canonical" href="http://www.renrendonghua.com">`
    };
  },
  serverPrefetch() {
    let id = this.$route.query.id
    if(id){
      this.id=id;
    }
    return this.fetchData();
  },
  destroyed() {
    this.$store.commit("SET_MODEL_DETAIL", {detail: null})
  },
  computed: {
    ...mapState(["activityInfoDetail"])
  },
  mounted() {
      this.isMounted = true;

    const alreadyIncremented = !!this.activityInfoDetail
    if (!alreadyIncremented) {
      this.fetchData().then(
          setTimeout(() => {
            this.initData()
          }, 1500)
      );
    } else {
      setTimeout(() => {
        this.initData()
      }, 500)
    }


  },
  methods:{
    initData() {
      let _this = this;
      let id = _this.$route.query.id
      if(id){
        _this.id=id;
      }else{
        _this.$router.push({
          path:'/error',
        })
      }
      _this.getActivity();
      _this.shareUrl=encodeURIComponent('http://www.renrendonghua.com/pro/detail?plate=3&id='+this.id);
      _this.shareUrl2='http://www.renrendonghua.com/pro/detail?plate=3&id='+this.id;
    },
    setSeo() {
      this.headTitle = this.activityInfoDetail.activityName + "——模型库——人人动画网【官网】"
      this.headKeywords = this.activityInfoDetail.showProType
      this.headDesc = "人人动画，一直致力于为动画项目外包提供完美解决方案。在这里，你可以发布脚本外包，分镜外包，动画外包，音效外包，后期剪辑外包，整个动画制作外包。"
    },
    fetchData(){
      return this.$store
          .dispatch("FETCH_ACTIVITY_INFO_DETAIL", {
            id: this.$route.query.id
          })
          .finally(() => {
            this.$loading(false);
            this.setSeo()
            updateTdk.call(this);
          });
    },
    share () {

      this.dialogVisibleShare = true
    },
    handleInput(e) {
      console.log(e)
      this.formOption.projectOffer = e.replace(/\D/g, '').replace(/^0{1,}/g, '');
    },
    check_code:function () {
      let _this=this;
      let time= new Date().getMilliseconds();
      let url='/api/checkcode?time='+time;
      this.$axios.get(url,{responseType: 'arraybuffer'}).then(function(result){
        let img_url='data:image/png;base64,' + btoa(new Uint8Array(result.data).reduce((data, byte) => data + String.fromCharCode(byte), ''));
        _this.registerCheckImg=img_url;
      })
    },
    setTime () {
      let _this=this;
      let postData = {
        'mobile':this.formOption.mobile,
        'captchaValue':this.registerImgCode
      }
        if(!this.formOption.mobile){
            _this.$message({
                message: '手机号码不能为空',
                type: 'warning'
            });
            return false;
        }
        const reg = /^1[1|2|3|4|5|6|7|8|9][0-9]\d{8}$/
        if (!reg.test(this.formOption.mobile)) {
            _this.$message({
                message: '手机号码格式有误',
                type: 'warning'
            });
            return false;
        }
      let url='/api/checkcode?time='+ new Date().getMilliseconds()+"&captchaCheck=1";
      this.$axios.post(url, qs.stringify(postData)).then(function(result){
        console.log("result.data",result);
        if(result.data.code=="23"){
          _this.$message({
            message: '由于您的操作过于频繁，系统已暂停登录服务，请您明天再来尝试',
            type: 'warning'
          });
          return false;
        }
        if(result.data==1){
          _this.$message({
            message: '图形验证码不能为空',
            type: 'warning'
          });
          return false;
        }
        if(result.data==2){
          _this.$message({
            message: '图形验证码填写错误',
            type: 'warning'
          });
          return false;
        }
        if(result.data==-1){
          _this.time = 60
          _this.interval = setInterval(() => {
            _this.time = _this.time - 1
            if(_this.time === 0) {
              clearInterval(_this.interval)
            }
          }, 1000)
        }
      })


    },
    set(title,type,content){
      document.title = title
      let head = document.getElementsByTagName('head');
      let meta = document.createElement('meta');
      // document.querySelector('meta[name="keywords"]').setAttribute('content', type)
      // document.querySelector('meta[name="description"]').setAttribute('content', content)
    },
    getActivity(){
      let _this=this;
      let url="/rrbi/activity/project-one?id="+_this.id+"&ti="+new Date().getMilliseconds();
      _this.$axios.get(url).then(function(result){
        if(result.data.code==1){
          _this.show=true;
          _this.activityInfo=result.data.response;
          let content=_this.activityInfo.activityDescription.replace(/<\/?.+?>/g,"").substring(0,150)
        }else{
          _this.$router.push({
            path:'/error',
          })
        }

      })
    },
    quoted(){
      let _this=this;
        _this.formOption={};
        _this.registerYzm="";
        _this.registerImgCode="";
      let url="/rrbi/activity/quoted?activityId="+_this.id+"&ti="+new Date().getMilliseconds();
      // let url="/py/project/quoted/?id="+_this.id+"&ti="+new Date().getMilliseconds();

      _this.$axios.get(url).then(function(result){
          console.log(result);
          let code=result.data.code;
          if(code==200){
            _this.dialogBaojia=true;
            _this.formOption=result.data.object;
            _this.check_code();
            _this.checked = false;
            _this.loading = false;
          }else if(code==0){//未登录
            _this.$router.push({
              path: '/login?callback=http://www.renrendonghua.com/pro/detail?plate=3&id='+_this.id,
            })
          }else if(code==1){//已结束
            _this.dialogActover=true;
          }else if(code==2){//用户不是合伙人,发布过作品
            _this.dialogNoqx2=true;
          }else if(code==3){//用户不是合伙人,没发布过作品
            _this.dialogNoqx3=true;
          }
      })
    },
    goChatRoom(){
        window.open("/chatroom?id="+global_.csId)
      // this.$router.push("/chatroom?id="+global_.csId)
    },
    applyFor(){
      let _this=this;
      let url="/rrbi/activity/applyFor?ti="+new Date().getMilliseconds();
      _this.$axios.get(url).then(function(result){
          if(result.data==1){
            _this.$message.success("申请成功，请耐心等待审核")
          }else if(result.data==2){
            _this.$message.success("您已经是合伙人啦，可以参与项目报价")
          }else{
            _this.$message.error("申请失败，请稍后再试，或联系管理员")
          }
      })
    },
    applyForAndGotoI(){
      let _this=this;
      let url="/rrbi/activity/applyFor?ti="+new Date().getMilliseconds();
      _this.$axios.get(url).then(function(result){
        if(result.data==1){
          window.open("http://i.renrendonghua.com")
        }else if(result.data==2){
          _this.$message.success("您已经是合伙人啦，可以参与项目报价")
        }else{
          _this.$message.error("申请失败，请稍后再试，或联系管理员")
        }
      })
    },

    addResult(){
        console.log(this.activityInfo)
        let _this=this;
        _this.loading=true;
        if(!this.formOption.mobile){
            _this.$message({
                message: '手机号码不能为空',
                type: 'warning'
            });
            return false;
        }
        const reg = /^1[1|2|3|4|5|6|7|8|9][0-9]\d{8}$/
        if (!reg.test(this.formOption.mobile)) {
            _this.$message({
                message: '手机号码格式有误',
                type: 'warning'
            });
            return false;
        }
        if(!_this.checked){
            _this.$message({
                message: '请先同意合作协议',
                type: 'warning'
            });
            _this.loading=false;
            return false;
        }
        if(!_this.registerYzm){
            _this.$message({
                message: '手机验证码不能为空',
                type: 'warning'
            });
            _this.loading=false;
            return false;
        }
      if(_this.formOption.projectOffer.length>9){
        _this.$message({
          message: '报价过高，不能超过9位数',
          type: 'warning'
        });
        _this.loading=false;
        return false;
      }
        _this.formOption.captcha=_this.registerYzm
        // let postData=_this.formOption
      let postData={
        id:_this.formOption.id,
        resultType:_this.formOption.resultType,
        projectOffer:_this.formOption.projectOffer,
        mobile:_this.formOption.mobile,
        commiterName:_this.formOption.commiterName,
        commiterId:_this.formOption.commiterId,
        captcha:_this.formOption.captcha,
        activityId:_this.formOption.activityId,
      }
        console.log("postData",postData)
        let url="/rrbi/activity/addActivityResult";
        _this.$axios.post(url, qs.stringify(postData)).then(function (result) {
            console.log(result)
            if(result.data.code==1){
              _this.$message({
                message: "报价成功",
                type: 'success'
              });
              _this.dialogBaojia = false;
            }else{
              _this.$message({
                message: result.data.message,
                type: 'warning'
              });
              _this.loading=false;
            }

        })

    },
    shareMy(){
      if(!global_.isLogin){
        this.$router.push({
          path: '/login?callback=http://www.renrendonghua.com/pro/detail?plate=3&id='+this.$route.query.id,
        })
        return false;
      }
      apiService.doshare({"objectType": 3, "objectId": this.activityInfo.id,"belongSection":this.activityInfo.belongSection,"shareTo":1,"time": new Date().getMilliseconds()}).then(data => {
        this.$message.success("成功分享到我的动态!");
      })
    },
    shareWechat () {
      this.dialogVisibleShareWechat = true
      apiService.doshare({"objectType": 3, "objectId": this.activityInfo.id,"belongSection":this.activityInfo.belongSection,"shareTo":1,"time": new Date().getMilliseconds()}).then(data => {

        let thiss=this
        this.$nextTick(() => {
          document.getElementById("qrcode").innerHTML = "";
          let uu=["a","b","c","d","e","f","g","h","i","j"]
          let t=(new Date().getTime()+""+new Date().getMilliseconds()).toString().split('');
          let uuid="";
          t.forEach(function (e) {
            uuid=uuid+uu[e]+"";
          })
          new thiss.QRCode(this.$refs.qrcode, {
            width: 100,
            height: 100,
            text: "http://www.renrendonghua.com/postprojectpost/postproject-v1?id="+this.activityInfo.id+"&tme="+new Date().getMilliseconds()
          })
        })
      })
    },
    shareWeibo () {
      apiService.doshare({"objectType": 3, "objectId": this.activityInfo.id,"belongSection":this.activityInfo.belongSection,"shareTo":1,"time": new Date().getMilliseconds()}).then(data => {

        const url = this.shareUrl
        const title = this.activityInfo.activityName
        const pic = this.activityInfo.activityImage
        const appkey = '#_loginLayer_1578022321857'
        const link = `http://service.weibo.com/share/share.php?url=${url}&title=${title}&pic=${pic}&appkey=${appkey}`
        window.open(link)
      })
    },
    shareQQzone () {
      apiService.doshare({"objectType": 3, "objectId": this.activityInfo.id,"belongSection":this.activityInfo.belongSection,"shareTo":1,"time": new Date().getMilliseconds()}).then(data => {

        const url =this.shareUrl
        const title = this.activityInfo.activityName
        const desc = ''
        const summary = ''
        const pic = this.activityInfo.activityImage
        const site = '%E4%B8%AA%E4%BA%BA%E4%B8%AD%E5%BF%83'
        const link = `https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=${url}&title=${title}&desc=${desc}&summary=${summary}&site=${site}&pics=${pic}`
        window.open(link)
      })
    },
    // copyLink () {
    //   console.log(this.activityInfo.id)
    //   apiService.doshare({"objectType": 3, "objectId": this.activityInfo.id,"shareTo":1,"time": new Date().getMilliseconds()}).then(data => {
    //
    //     let Url2 = decodeURIComponent(this.shareUrl);
    //     const input = document.createElement('input')
    //     document.body.appendChild(input)
    //     input.setAttribute('value',Url2)
    //     input.select()
    //     if (document.execCommand('copy')) {
    //       document.execCommand('copy')
    //     }
    //     document.body.removeChild(input)
    //
    //     this.$message.success("复制成功");
    //   })
    // },
    copyLink() {
      var clipboard = new Clipboard('.tag-read')
      clipboard.on('success', e => {
        this.$message.success("复制成功");
        // 释放内存
        clipboard.destroy()
      })
      clipboard.on('error', e => {
        // 不支持复制
        this.$message.error("此浏览器不支持复制")
        // 释放内存
        clipboard.destroy()
      })
    },
    poster(){
      let link="http://www.renrendonghua.com/poster?id="+this.activityInfo.id;
      window.open(link)
    },
  }

}
</script>

<style scoped lang="less">
//@import "../../../assets/less/stylePublic.less";
@import "../pro.less";
.collect-matchs-detail .rich-text{
  padding: 0;
}
@media screen and (min-width: 1100px) {
  .collect-matchs-detail{
    width: 956px;
  }
}
.page-prodetail{
  padding-top: @NAVHEIGHT;
  .much{
    padding-top: 50px;
    height: 90px;
    color: #999;
    text-align: center;
    background: #fff;
    span{
      color: #000;
    }
  }
  .rich-text{
    margin-top: 15px;
    min-height: 600px;
    background: #fff;
  }
}
.dialog-form{
  .form-item{
    display: flex;
    margin-bottom: 20px;
    line-height: 32px;
    .tit{
      flex: 0 0 100px;
      width: 100px;
    }
    .rig-ipt{
      flex: 1;
      &.yz-ipt{
        display: flex;
        .yz-img{
          margin-left: 10px;
          flex: 0 0 100px;
          width: 100px;
          img{
            width: 100%;
            height: 32px;
          }
        }
        .ipt{
          flex: 1;
        }
      }
    }
  }
  .xieyi{
    text-align: center;
    span{
      color: #3e65e6;
      text-decoration: underline;
      cursor: pointer;
    }
  }
}
.get-qx{
  text-align: center;
  .qx-a{
    color: #535bee;
  }
}
.act-words{
  display: block;
  padding-bottom: 20px;
  text-align: center;
}
.right-side-btns{
  position: fixed;
  top: 50%;
  margin-top: -60px;
  width: 100px;
  li{
    margin: 4px 0;
    padding: 5px 0;
    height: 36px;
    line-height: 26px;
    text-align: center;
    color: #fff;
    font-size: 16px;
    background: #7b7b7b;
    border-radius: 4px;
    cursor: pointer;
  }
}
@media screen and (max-width: 750px) {
  .right-side-btns{
    width: 70px;
    li{
      padding: 0;
      height: 26px;
      font-size: 12px;
    }
  }
  .dialog-form{
    .form-item{
      .tit{
        flex: 0 0 60px;
        width: 60px;
        font-size: 12px;
      }
      /deep/.el-input{
        input{
          padding-left: 10px;
        }
      }
    }
  }
  /deep/.el-dialog__body{
    padding: 10px 15px;
  }
}
@media screen and (max-width: 1249px) {
  .right-side-btns{
    right: 0;
  }
}
@media screen and (min-width: 1250px) {
  .right-side-btns{
    right: 50%;
    margin-right: 488px;
  }
}
</style>
